<template>
  <div class="searchAreaStyle d-flex align-center">
    <div class="titleStyle">調整商品</div>
    <div class="textStyle px-5" v-if="search">
      <v-text-field
        v-bind:value="input.keyword"
        @input="inputKeyword"
        :placeholder="$t('sale.sale_input-keywords')"
        outlined
        dense
        hide-details
      >
      </v-text-field>
    </div>
    <div class="mr-1" v-if="search">
      <SelectProductCategory v-model="input.category" />
    </div>
  </div>
</template>
<script>
import { SelectProductCategory } from '@/components/items'

export default {
  components: {
    SelectProductCategory
  },
  data: () => ({
    input: {
      keyword: '',
      category: ''
    }
  }),
  props: {
    search: { default: true }
  },
  methods: {
    inputKeyword(event) {
      this.$emit('inputKeyword', event)
    }
  },
  watch: {
    'input.category': {
      deep: true,
      handler(newVal, oldVal) {
        this.$emit('selectCategory', newVal)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.titleStyle {
  font-size: 18px;
  font-weight: bold;
}
.searchAreaStyle {
  height: 70px;
}
.selectBoxStyle {
  width: 340px;
  //   margin: 0px 16px 0px 63px !important;
  margin-left: 30px;
  margin-right: 20px;
}
.textButtonStyle {
  margin: 0px 21px;
}
.textStyle {
  width: 280px;
}
</style>
